<template>
  <nav
    class="navbar navbar-expand-md navbar-light d-none d-md-flex fixed-top"
    id="topbar"
  >
    <div class="container-fluid justify-content-end">
      <a class="navbar-brand" href="/">
        <img
          src="../assets/img/ubudget.png"
          class="navbar-brand-img mx-auto"
          alt="..."
        />
      </a>

      <div class="navbar-user">
        <div class="dropdown me-4 d-none d-md-flex">
          <!-- Menu -->
          <div class="dropdown-menu dropdown-menu-end dropdown-menu-card">
            <div class="card-header">
              <!-- Title -->
              <h5 class="card-header-title">Notifications</h5>

              <!-- Link -->
              <a href="#!" class="small"> View all </a>
            </div>
            <!-- / .card-header -->
            <div class="card-body">
              <!-- List group -->
              <div
                class="list-group list-group-flush list-group-activity my-n3"
              >
                <a class="list-group-item text-reset" href="#!">
                  <div class="row">
                    <div class="col-auto">
                      <!-- Avatar -->
                      <div class="avatar avatar-sm">
                        <img
                          src="../assets/img/avatars/profiles/avatar-1.jpg"
                          alt="..."
                          class="avatar-img rounded-circle"
                        />
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <!-- Content -->
                      <div class="small">
                        <strong>Dianna Smiley</strong> shared your post with Ab
                        Hadley, Adolfo Hess, and 3 others.
                      </div>

                      <!-- Time -->
                      <small class="text-muted"> 2m ago </small>
                    </div>
                  </div>
                  <!-- / .row -->
                </a>
                <a class="list-group-item text-reset" href="#!">
                  <div class="row">
                    <div class="col-auto">
                      <!-- Avatar -->
                      <div class="avatar avatar-sm">
                        <img
                          src="../assets/img/avatars/profiles/avatar-2.jpg"
                          alt="..."
                          class="avatar-img rounded-circle"
                        />
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <!-- Content -->
                      <div class="small">
                        <strong>Ab Hadley</strong> reacted to your post with a
                        😍
                      </div>

                      <!-- Time -->
                      <small class="text-muted"> 2m ago </small>
                    </div>
                  </div>
                  <!-- / .row -->
                </a>
                <a class="list-group-item text-reset" href="#!">
                  <div class="row">
                    <div class="col-auto">
                      <!-- Avatar -->
                      <div class="avatar avatar-sm">
                        <img
                          src="../assets/img/avatars/profiles/avatar-3.jpg"
                          alt="..."
                          class="avatar-img rounded-circle"
                        />
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <!-- Content -->
                      <div class="small">
                        <strong>Adolfo Hess</strong> commented
                        <blockquote class="mb-0">
                          “I don’t think this really makes sense to do without
                          approval from Johnathan since he’s the one...”
                        </blockquote>
                      </div>

                      <!-- Time -->
                      <small class="text-muted"> 2m ago </small>
                    </div>
                  </div>
                  <!-- / .row -->
                </a>
                <a class="list-group-item text-reset" href="#!">
                  <div class="row">
                    <div class="col-auto">
                      <!-- Avatar -->
                      <div class="avatar avatar-sm">
                        <img
                          src="../assets/img/avatars/profiles/avatar-4.jpg"
                          alt="..."
                          class="avatar-img rounded-circle"
                        />
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <!-- Content -->
                      <div class="small">
                        <strong>Daniela Dewitt</strong> subscribed to you.
                      </div>

                      <!-- Time -->
                      <small class="text-muted"> 2m ago </small>
                    </div>
                  </div>
                  <!-- / .row -->
                </a>
                <a class="list-group-item text-reset" href="#!">
                  <div class="row">
                    <div class="col-auto">
                      <!-- Avatar -->
                      <div class="avatar avatar-sm">
                        <img
                          src="../assets/img/avatars/profiles/avatar-5.jpg"
                          alt="..."
                          class="avatar-img rounded-circle"
                        />
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <!-- Content -->
                      <div class="small">
                        <strong>Miyah Myles</strong> shared your post with Ryu
                        Duke, Glen Rouse, and 3 others.
                      </div>

                      <!-- Time -->
                      <small class="text-muted"> 2m ago </small>
                    </div>
                  </div>
                  <!-- / .row -->
                </a>
                <a class="list-group-item text-reset" href="#!">
                  <div class="row">
                    <div class="col-auto">
                      <!-- Avatar -->
                      <div class="avatar avatar-sm">
                        <img
                          src="../assets/img/avatars/profiles/avatar-6.jpg"
                          alt="..."
                          class="avatar-img rounded-circle"
                        />
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <!-- Content -->
                      <div class="small">
                        <strong>Ryu Duke</strong> reacted to your post with a 😍
                      </div>

                      <!-- Time -->
                      <small class="text-muted"> 2m ago </small>
                    </div>
                  </div>
                  <!-- / .row -->
                </a>
                <a class="list-group-item text-reset" href="#!">
                  <div class="row">
                    <div class="col-auto">
                      <!-- Avatar -->
                      <div class="avatar avatar-sm">
                        <img
                          src="../assets/img/avatars/profiles/avatar-7.jpg"
                          alt="..."
                          class="avatar-img rounded-circle"
                        />
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <!-- Content -->
                      <div class="small">
                        <strong>Glen Rouse</strong> commented
                        <blockquote class="mb-0">
                          “I don’t think this really makes sense to do without
                          approval from Johnathan since he’s the one...”
                        </blockquote>
                      </div>

                      <!-- Time -->
                      <small class="text-muted"> 2m ago </small>
                    </div>
                  </div>
                  <!-- / .row -->
                </a>
                <a class="list-group-item text-reset" href="#!">
                  <div class="row">
                    <div class="col-auto">
                      <!-- Avatar -->
                      <div class="avatar avatar-sm">
                        <img
                          src="../assets/img/avatars/profiles/avatar-8.jpg"
                          alt="..."
                          class="avatar-img rounded-circle"
                        />
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <!-- Content -->
                      <div class="small">
                        <strong>Grace Gross</strong> subscribed to you.
                      </div>

                      <!-- Time -->
                      <small class="text-muted"> 2m ago </small>
                    </div>
                  </div>
                  <!-- / .row -->
                </a>
              </div>
            </div>
          </div>
          <!-- / .dropdown-menu -->
        </div>
        <b-nav-item-dropdown right style="list-style-type: none">
          <!-- Using 'button-content' slot -->
          <template #button-content>
            <div>
              <i class="fe fe-user"></i>
              {{ printName() }}
              <i class="fe fe-chevron-down"></i>
            </div>
          </template>
          <b-dropdown-item href="#" @click.prevent="logout">
            Logout
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </div>
    </div>
  </nav>
</template>

<script>
import lang from "@/lang.json";
import axios from "axios";
import querystring from "query-string";
export default {
  data() {
    return {};
  },
  methods: {
    changesLang() {
      this.changeLang = !this.changeLang;
      // console.log(lang.en.sidebar);
      if (this.changeLang == false) {
        // Master Data
        this.menus[0].name = lang.lang.en.sidebar.home;
        this.menus[1].name = lang.lang.en.sidebar.masterData.title;
        this.menus[2].name = lang.lang.en.sidebar.healthcare_facility;
        this.menus[3].name = lang.lang.en.sidebar.oh_management;

        // Master Data - Disease
        this.menus[1].child[0].name =
          lang.lang.en.sidebar.masterData.child.disease.title;
        this.menus[1].child[0].child[0].name =
          lang.lang.en.sidebar.masterData.child.disease.child.chapter;
        this.menus[1].child[0].child[1].name =
          lang.lang.en.sidebar.masterData.child.disease.child.block;
        this.menus[1].child[0].child[2].name =
          lang.lang.en.sidebar.masterData.child.disease.child.category;
        this.menus[1].child[0].child[3].name =
          lang.lang.en.sidebar.masterData.child.disease.child.disease;

        // Master Data - Inventory
        this.menus[1].child[1].name =
          lang.lang.en.sidebar.masterData.child.inventory.title;
        this.menus[1].child[1].child[0].name =
          lang.lang.en.sidebar.masterData.child.inventory.child.category;
        this.menus[1].child[1].child[1].name =
          lang.lang.en.sidebar.masterData.child.inventory.child.drug;
        // this.menus[1].child[1].child[2].name = lang.lang.en.sidebar.masterData.child.inventory.child.inventory

        // Master Data - Chemical
        this.menus[1].child[2].name =
          lang.lang.en.sidebar.masterData.child.chemical.title;
        this.menus[1].child[2].child[0].name =
          lang.lang.en.sidebar.masterData.child.chemical.child.type;
        this.menus[1].child[2].child[1].name =
          lang.lang.en.sidebar.masterData.child.chemical.child.hazard;
        this.menus[1].child[2].child[2].name =
          lang.lang.en.sidebar.masterData.child.chemical.child.name;

        // Master Data - Medical
        this.menus[1].child[3].name =
          lang.lang.en.sidebar.masterData.child.medical.title;
        this.menus[1].child[3].child[0].name =
          lang.lang.en.sidebar.masterData.child.medical.child.facility;
        this.menus[1].child[3].child[1].name =
          lang.lang.en.sidebar.masterData.child.medical.child.treatment;
        this.menus[1].child[3].child[2].name =
          lang.lang.en.sidebar.masterData.child.medical.child.position;
        this.menus[1].child[3].child[3].name =
          lang.lang.en.sidebar.masterData.child.medical.child.group;
        this.menus[1].child[3].child[4].name =
          lang.lang.en.sidebar.masterData.child.medical.child.subgroup;

        // Master Data - MCU
        // this.menus[1].child[4].name = lang.lang.en.sidebar.masterData.child.medical.title
        this.menus[1].child[4].child[0].name =
          lang.lang.en.sidebar.masterData.child.mcu.child.category;
        this.menus[1].child[4].child[1].name =
          lang.lang.en.sidebar.masterData.child.mcu.child.result;
        this.menus[1].child[4].child[2].name =
          lang.lang.en.sidebar.masterData.child.mcu.child.group;
        this.menus[1].child[4].child[3].name =
          lang.lang.en.sidebar.masterData.child.mcu.child.item;

        // Master Data - IH
        // this.menus[1].child[5].name = lang.lang.en.sidebar.masterData.child.medical.title
        this.menus[1].child[5].child[0].name =
          lang.lang.en.sidebar.masterData.child.ih.child.action;
        this.menus[1].child[5].child[1].name =
          lang.lang.en.sidebar.masterData.child.ih.child.faktor;
        this.menus[1].child[5].child[2].name =
          lang.lang.en.sidebar.masterData.child.ih.child.activity;
        this.menus[1].child[5].child[3].name =
          lang.lang.en.sidebar.masterData.child.ih.child.method;
        this.menus[1].child[5].child[4].name =
          lang.lang.en.sidebar.masterData.child.ih.child.unit;

        // Master Data - OH
        // this.menus[1].child[5].name = lang.lang.en.sidebar.masterData.child.medical.title
        this.menus[1].child[6].child[0].name =
          lang.lang.en.sidebar.masterData.child.oh.child.activity;
        this.menus[1].child[6].child[1].name =
          lang.lang.en.sidebar.masterData.child.oh.child.indicator;
        this.menus[1].child[6].child[2].name =
          lang.lang.en.sidebar.masterData.child.oh.child.data;
      } else {
        // Master Data
        this.menus[0].name = lang.lang.id.sidebar.home;
        this.menus[1].name = lang.lang.id.sidebar.masterData.title;
        this.menus[2].name = lang.lang.id.sidebar.healthcare_facility;
        this.menus[3].name = lang.lang.id.sidebar.oh_management;

        // Master Data - Disease
        this.menus[1].child[0].name =
          lang.lang.id.sidebar.masterData.child.disease.title;
        this.menus[1].child[0].child[0].name =
          lang.lang.id.sidebar.masterData.child.disease.child.chapter;
        this.menus[1].child[0].child[1].name =
          lang.lang.id.sidebar.masterData.child.disease.child.block;
        this.menus[1].child[0].child[2].name =
          lang.lang.id.sidebar.masterData.child.disease.child.category;
        this.menus[1].child[0].child[3].name =
          lang.lang.id.sidebar.masterData.child.disease.child.disease;

        // Master Data - Inventory
        this.menus[1].child[1].name =
          lang.lang.id.sidebar.masterData.child.inventory.title;
        this.menus[1].child[1].child[0].name =
          lang.lang.id.sidebar.masterData.child.inventory.child.category;
        this.menus[1].child[1].child[1].name =
          lang.lang.id.sidebar.masterData.child.inventory.child.drug;
        // this.menus[1].child[1].child[2].name = lang.lang.id.sidebar.masterData.child.inventory.child.inventory

        // Master Data - Chemical
        this.menus[1].child[2].name =
          lang.lang.id.sidebar.masterData.child.chemical.title;
        this.menus[1].child[2].child[0].name =
          lang.lang.id.sidebar.masterData.child.chemical.child.type;
        this.menus[1].child[2].child[1].name =
          lang.lang.id.sidebar.masterData.child.chemical.child.hazard;
        this.menus[1].child[2].child[2].name =
          lang.lang.id.sidebar.masterData.child.chemical.child.name;

        // Master Data - Medical
        this.menus[1].child[3].name =
          lang.lang.id.sidebar.masterData.child.medical.title;
        this.menus[1].child[3].child[0].name =
          lang.lang.id.sidebar.masterData.child.medical.child.facility;
        this.menus[1].child[3].child[1].name =
          lang.lang.id.sidebar.masterData.child.medical.child.treatment;
        this.menus[1].child[3].child[2].name =
          lang.lang.id.sidebar.masterData.child.medical.child.position;
        this.menus[1].child[3].child[3].name =
          lang.lang.id.sidebar.masterData.child.medical.child.group;
        this.menus[1].child[3].child[4].name =
          lang.lang.id.sidebar.masterData.child.medical.child.subgroup;

        // Master Data - MCU
        // this.menus[1].child[4].name = lang.lang.en.sidebar.masterData.child.medical.title
        this.menus[1].child[4].child[0].name =
          lang.lang.id.sidebar.masterData.child.mcu.child.category;
        this.menus[1].child[4].child[1].name =
          lang.lang.id.sidebar.masterData.child.mcu.child.result;
        this.menus[1].child[4].child[2].name =
          lang.lang.id.sidebar.masterData.child.mcu.child.group;
        this.menus[1].child[4].child[3].name =
          lang.lang.id.sidebar.masterData.child.mcu.child.item;

        // Master Data - IH
        // this.menus[1].child[5].name = lang.lang.en.sidebar.masterData.child.medical.title
        this.menus[1].child[5].child[0].name =
          lang.lang.id.sidebar.masterData.child.ih.child.action;
        this.menus[1].child[5].child[1].name =
          lang.lang.id.sidebar.masterData.child.ih.child.faktor;
        this.menus[1].child[5].child[2].name =
          lang.lang.id.sidebar.masterData.child.ih.child.activity;
        this.menus[1].child[5].child[3].name =
          lang.lang.id.sidebar.masterData.child.ih.child.method;
        this.menus[1].child[5].child[4].name =
          lang.lang.id.sidebar.masterData.child.ih.child.unit;

        // Master Data - OH
        // this.menus[1].child[5].name = lang.lang.en.sidebar.masterData.child.medical.title
        this.menus[1].child[6].child[0].name =
          lang.lang.id.sidebar.masterData.child.oh.child.activity;
        this.menus[1].child[6].child[1].name =
          lang.lang.id.sidebar.masterData.child.oh.child.indicator;
        this.menus[1].child[6].child[2].name =
          lang.lang.id.sidebar.masterData.child.oh.child.data;
      }
    },
    async logout() {
      try {
        this.$router.push("/");
        const logout_url = `${process.env.VUE_APP_KEYCLOAK_URL}/realms/${
          process.env.VUE_APP_KEYCLOAK_REALM || "ugems"
        }/protocol/openid-connect/logout`;
        const client_id =
          process.env.VUE_APP_KEYCLOAK_CLIENT_ID || "url-shortener";
        const access_token = localStorage.getItem("ugems-accessToken");
        const refresh_token = localStorage.getItem("ugems-refreshToken");
        const payload = querystring.stringify({
          client_id,
          refresh_token,
        });

        const headers = {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: access_token,
        };

        await axios.post(logout_url, payload, headers);
        window.location.reload();
      } catch (err) {
        console.log("Error on logout", err);
      }
    },
    printName() {
      const stringUser = localStorage.getItem("ugems-tokenParsed");
      if (stringUser) {
        const user = JSON.parse(stringUser);
        const given_name = user.given_name;
        return given_name;
      }
      return "Unknown";
    },
  },
};
</script>

<style></style>
